import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { userProfile } from 'utils/auth';
import { rolesEnum } from './data/type';

// Special route for AI Avatar Layout - Only for beta_maiq_performance_manager role
export const AIAvatarRoute = ({ component: Component, ...rest }: any) => {
  const user = userProfile(false);

  if (!user || !Object.keys(user).length) {
    return <Redirect to="/login" />;
  }

  const userRoles = user?.roles || [];
  const isBetaPerformanceManager = userRoles.includes(rolesEnum.betaPerformanceManager);

  // If user has beta_maiq_performance_manager role, allow access to AI Avatar Layout
  if (isBetaPerformanceManager) {
    return <Route component={Component} {...rest} />;
  }

  // Otherwise redirect to their appropriate homepage
  return <Redirect to="/" />;
};

// Check if user should be restricted to AI Avatar Layout only
export const shouldRestrictToAILayout = (userRoles: string[]): boolean => {
  return userRoles.includes(rolesEnum.betaPerformanceManager);
};


